import React from 'react';

const LoadingSpinner = ({ size = 'md', className = '' }) => {
  let spinnerSizeClass;
  switch (size) {
    case 'sm':
      spinnerSizeClass = 'h-4 w-4';
      break;
    case 'lg':
      spinnerSizeClass = 'h-8 w-8';
      break;
    case 'xl':
      spinnerSizeClass = 'h-10 w-10';
      break;
    case 'md':
    default:
      spinnerSizeClass = 'h-6 w-6';
      break;
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className={`animate-spin rounded-full border-b-2 border-gray-900 ${spinnerSizeClass}`}></div>
    </div>
  );
};

export default LoadingSpinner;